export default __webpack_public_path__ + "favicons/fav-dev-32.png";